<template>

  <div class="product-card-500-subscription-wrapper">
    <div class="inner_container">
      <div class="btn row mx-auto justify-content-center mb-2">
        <span class="pricing_btn active_bg yearly " data-class="pricing2">
          {{ product.name }}
        </span>
      </div>
      <div v-for="productFeature in productTableFeature(product)" class="d-block">
        <template v-if="productFeature.feature != null">
          <template v-if="productFeature.feature.type == 'date'">
            <div class="mb-2 d-block">
              {{ productFeatureName(product, productFeature.id) }}:{{
                dateConverter(productFeatureValue(product, productFeature.id), '/', false)
              }}
            </div>
          </template>
          <template v-else>
            <div class="mb-2 d-block">
              <span class="feature-products-500">{{ productFeatureName(product, productFeature.id) }}</span>:<span
                class="feature-products-500">{{ productFeatureValue(product, productFeature.id) }}</span>
            </div>
          </template>
        </template>
      </div>
      <div class="pricing pricing1 active">
        <div class="col-12 price-card-title pb-2 px-0">
          <template v-if="product.variation == 1" v-for="feature in productFeatureSubProduct(product)">
            <ProductCard500PriceManager class="  "
                                        :product="product"
                                        :sub_product="feature.id"
                                        :feature="feature"/>
          </template>
          <ProductCard500PriceManager v-else :product="product"/>
        </div>


      </div>

    </div>
  </div>


</template>

<script>
import {mapGetters} from "vuex";
import mCard516 from "../../../Cards/Card516.vue";
import mProductCardQuantityManager1 from "../../QuantityManager/Card/ProductCardQuantityManager1.vue";
import mProductPrice500 from "../../ProductPrice500.vue";
import mA from '../../../Tags/A.vue'
import mIcon from '../../../Icons/Icon.vue'
import mProductOffer1 from "../../ProductOffer/ProductOffer1.vue";
import {OfferProps} from '../../ProductOffer/ProductOfferProps'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  addFeatureToProduct,
  featureCategories,
  findFeatureWithSelectedName,
  groupByType,
  productFeatureName,
  productFeatureSubProduct,
  productFeatureValue,
  productTableFeature,
  removeChildFeature,
  removeEmptyGroups,
  sortedFeaturesMethod
} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import mDelete1 from "../../../Tool/Delete/Delete1.vue";
import ProductCard500PriceManager from "./ProductCard500_subscriptionPriceManager.vue";
import VariationProduct from "../../SingleProductPrice3/VariationProduct.vue";

export default {
  name: "ProductCard500_subscription",
  components: {
    ProductCard500PriceManager,
    mCard516,
    mDelete1,
    mProductCardQuantityManager1,
    mA,
    mProductPrice500,
    mProductOffer1,
    mIcon,
    VariationProduct
  },
  props: {
    product: {},
    productCardLink: {
      default: '_self',
    },
    inActiveQuantityManager: {
      type: Boolean,
      default: true
    },
    showKeywords: {
      type: Boolean,
      default: false
    },
    OfferProps
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile"
    }),
    productFeatures() {
      return this.product.feature_product
    },
    publishStatus() {
      return this.product.status == 0 ? false : true
    },

  },
  methods: {
    productFeatureValue,
    productFeatureName,
    dateConverter,
    addFeatureToProduct,
    featureCategories,
    groupByType,
    removeChildFeature,
    removeEmptyGroups,
    sortedFeaturesMethod,
    findFeatureWithSelectedName,
    ...shoppingCartFunctions,
    productTableFeature,
    productFeatureSubProduct


  },
  mounted() {

    const pricing_btn = document.querySelectorAll(".pricing_btn ");
    const active_bg = document.querySelector(".active_bg");
    const pricing = document.querySelectorAll(".pricing");
    const payment = document.querySelectorAll(".payment ");
    const monthly = document.querySelectorAll(".monthly");
    const yearly = document.querySelectorAll(".yearly");
    const monthly_icon = document.querySelectorAll(".monthly_icon");
    const yearly_icon = document.querySelectorAll(".yearly_icon");


    pricing_btn.forEach(function (btn) {
      btn.addEventListener("click", function () {
        pricing_btn.forEach(btn => btn.classList.remove("active"));
        this.classList.add("active");
        // var active_width = this.offsetWidth;
        var active_left = this.offsetLeft;
        active_bg.style.cssText = "left:" + active_left + "px;";
        var class_name = this.getAttribute("data-class");
        pricing.forEach(function (c) {
          c.classList.remove("active");
        });
        document.querySelector("." + class_name).classList.add("active");
      });
    });

    payment.forEach(function (payment_btn) {
      payment_btn.addEventListener("click", function () {


        if (this.classList.contains("monthly")) {
          monthly.forEach(payment_btn => payment_btn.classList.remove("active"));
          this.classList.add("active");
          monthly_icon.forEach(select_icon => select_icon.classList.remove("active"));
          this.querySelector(".select_icon").classList.add("active");
        }
        if (this.classList.contains("yearly")) {
          yearly.forEach(payment_btn => payment_btn.classList.remove("active"));
          this.classList.add("active");
          yearly_icon.forEach(select_icon => select_icon.classList.remove("active"));
          this.querySelector(".select_icon").classList.add("active");
        }
      });
    });


  }


}
</script>

<style scoped>
.feature-products-500 {
  font-size: 14px;
  padding: 0px 4px;
  color: #323234;
  direction: rtl !important;

}


.product-card-500-subscription-wrapper {
  direction: rtl !important;
}

.inner_container {
  position: relative;
  max-width: 400px;
  width: 100%;
  padding: 15px;
  border: 2px solid #EAEAE9;
  border-radius: 25px;
  box-sizing: border-box;
  background: #fff;

}

.btn {
  position: relative;
  max-width: 100%;
  width: 100%;
  padding: 6px;
  box-sizing: border-box;
  background: #F4F3F8;
  border-radius: 30px;
  text-align: center;
  cursor: pointer;
  display: flex;
}

.active_bg {
  position: absolute;
  height: calc(100% - 12px);
  background: #fff;
  border-radius: 25px;
  transition: all .3s linear;
  width: calc(50% - 6px);
}

.pricing_btn {
  position: relative;
  display: inline-block;
  padding: 5px 15px;
  font-size: 17px;
  box-sizing: border-box;
  font-weight: 600;
  transition: all .3s linear;
  text-align: center;
  max-width: 50%;
  width: 100%;
  box-sizing: border-box;
}

.pricing {
  direction: ltr;
  position: relative;
  margin-top: 20px;
  display: none;
}

.pricing.active {
  display: block;
}


.free h2 {
  position: relative;
  margin: 0px;
  margin-bottom: 3px;
  font-weight: 500;
  font-size: 20px;
}

h2 span {
  position: relative;
  display: inline-block;
  font-size: 14px;
  background: #F2EBB9;
  padding: 6px 10px;
  border-radius: 5px;
  font-weight: normal;
}


.money span {
  position: relative;
  display: inline-block;
  font-weight: normal;
  color: #838388;
}


</style>